var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:rgb(17,24,39);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.4580078,6.3022461 4.4580078,5.5522461 3.3383787,5.5522461 3.3383787,5.1821284  3.7080076,5.1821284 3.7080078,6.3022461 4.4580078,6.3022461 4.4580078,5.5522461 4.4580078,6.3022461 5.2080073,6.3022461  5.2080073,3.6821289 1.8383789,3.6821289 1.8383789,7.0522456 5.2080073,7.0522456 5.2080073,6.3022461  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1879883,6.3671875h12.2094727c0.5522842,0,1-0.4477153,1-1s-0.4477158-1-1-1H9.1879883 c-0.5522852,0-1,0.4477148-1,1S8.6357031,6.3671875,9.1879883,6.3671875"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.4580078,12.8466797 4.4580078,12.0966797 3.3383787,12.0966797 3.3383787,11.7270498  3.7080076,11.7270498 3.7080078,12.8466797 4.4580078,12.8466797 4.4580078,12.0966797 4.4580078,12.8466797 5.2080073,12.8466797  5.2080073,10.2270508 1.8383789,10.2270508 1.8383789,13.5966787 5.2080073,13.5966787 5.2080073,12.8466797  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1879883,12.9116211h12.2094727c0.5522842,0,1-0.4477158,1-1c0-0.5522852-0.4477158-1-1-1H9.1879883 c-0.5522852,0-1,0.4477148-1,1C8.1879883,12.4639053,8.6357031,12.9116211,9.1879883,12.9116211"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4.4580078,19.3916016 4.4580078,18.6416016 3.3383787,18.6416016 3.3383787,18.2714806  3.7080076,18.2714806 3.7080078,19.3916016 4.4580078,19.3916016 4.4580078,18.6416016 4.4580078,19.3916016 5.2080073,19.3916016  5.2080073,16.7714844 1.8383789,16.7714844 1.8383789,20.1415997 5.2080073,20.1415997 5.2080073,19.3916016  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1879883,19.4560547h12.2094727c0.5522842,0,1-0.4477158,1-1c0-0.5522861-0.4477158-1-1-1H9.1879883 c-0.5522852,0-1,0.4477139-1,1C8.1879883,19.0083389,8.6357031,19.4560547,9.1879883,19.4560547"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list_view.cee113284b0ff912bdea0c585f4f2f7b.svg";
export { ForwardRef as ReactComponent };